import { Paperclip } from 'lucide-react';

import { FormBody } from '@/components/traceInspector/segmentDetail/formBody/formBody';
import { AvatarComponent } from '@/components/ui/avatar/avatar';
import { RichEditor } from '@/components/ui/richEditor';
import type { WidgetData } from '@/components/ui/widget/widget.type';
import {
  findNumberOfFiles,
  formatDateWithoutSeconds,
  pluralize
} from '@/utils';

type Props = {
  data: WidgetData;
  traceInspector?: boolean;
  searchValue?: string;
};

export const AnswerCard = ({
  data,
  traceInspector = false,
  searchValue = ''
}: Props) => {
  const avatarSrc = data.createdBy?.avatar || data.link?.createdBy?.avatar;
  const name = data.createdBy?.name || data.link?.createdBy?.name;
  const group = data.group?.name || data.link?.group?.name;
  const date = data.createdAt || data.link?.createdAt;
  const answer = data.data?.answer || data.link?.answer;

  const numberOfFiles = findNumberOfFiles(data.data);

  return (
    data && (
      <div className="mt-4 ml-4 flex border-border border-l-2 px-4 text-card-foreground hover:border-primary-deep">
        <AvatarComponent name={name} size={20} source={avatarSrc} />
        <div className="mx-3 w-full">
          <ul>
            {name && (
              <li className="flex flex-row flex-wrap items-center">
                <div className="mr-2.5 font-bold text-xs">{name}</div>
                {group && (
                  <div className="border-input border-l pl-2.5 text-[10px] text-muted-foreground">
                    {group}
                  </div>
                )}
              </li>
            )}
            <li>
              <p className="text-[10px] text-muted-foreground">
                on {formatDateWithoutSeconds(date.slice(0, 16))}
              </p>
            </li>
            {traceInspector ? (
              <FormBody
                link={data?.link}
                linkCreatedByAccount={data?.linkCreatedByAccount}
                workflowContext={data?.workflowContext}
              />
            ) : (
              <>
                <li>
                  <div className="mt-2 text-card-foreground">
                    <RichEditor
                      readOnly
                      searchValue={searchValue}
                      value={answer}
                    />
                  </div>
                </li>
                {!!numberOfFiles && (
                  <li className="relative pl-4 text-muted-foreground text-xs">
                    <Paperclip className="-l-2.5 absolute top-0.5 h-4" />
                    {`${pluralize(
                      numberOfFiles,
                      'Attachment'
                    )} (${numberOfFiles})`}
                  </li>
                )}
              </>
            )}
          </ul>
        </div>
      </div>
    )
  );
};
